import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {Eixo} from "../../core/eixo";

@Injectable({
    providedIn: "root",
})
export class EixoService extends BaseService<Eixo> {
    constructor(http: HttpClient) {
        super(http, Rotas.EIXO);
    }

    getByFilter(nome: string, descricao: string) {
        nome = nome || "";
        descricao = descricao || "";
        return this.http.get(Rotas.EIXO + `filter`, {
            params: {
                nome: `${nome}`,
                descricao: `${descricao}`
            },
        });
    }
}
